// extracted by mini-css-extract-plugin
export var alignCenter = "_8v-d";
export var bannerShown = "_8v-6";
export var buttonContent = "_8v-0";
export var cardList = "_8v-1";
export var centerContent = "_8v-2";
export var chevron = "_8v-3";
export var closePanelButton = "_8v-k";
export var conversationContextContainer = "_8v-l";
export var conversationDetailContainer = "_8v-4";
export var detailWrapper = "_8v-7";
export var dropdownButton = "_8v-e";
export var dropdownTitle = "_8v-9";
export var fullHeight = "_8v-5";
export var hidden = "_8v-a";
export var icon = "_8v-b";
export var mergeSuggestionWrapper = "_8v-m";
export var panel = "_8v-i";
export var portalButtonsWrapper = "_8v-c";
export var right = "_8v-j";
export var tableSummaryContainer = "_8v-8";
export var tableSummaryHeader = "_8v-g";
export var threeDotsButton = "_8v-f";
export var wide = "_8v-h";